"use strict";

import {Household, WritableHousehold} from "./Household";

class Households {
    private _ds: any;
    private _state: any;

    constructor(writeDs, data) {
        this._ds = writeDs;
        this.updateRsvpData(data);
    }

    updateRsvpData(data) {
        this._state = data;
    }

    createNewHousehold(title) {
        return this._hCreateRawHousehold({
            title: title
        });
    }

    get _hhs() {
        return this._state.households || {};
    }

    asArray() {
        return Object.keys(this._hhs)
            .map(hId => Household.createHousehold(this, hId));
    }

    asArrayFromPeople(people) {
        people.getKeys()
            .map(k => people.getPersonAtKey(k))
            .map(p => p.getHouseholdId())
            .reduce((acc, curr) => {
                if (acc.indexOf(curr) < 0) {
                    acc.push(curr);
                }
                return acc;
            }, [])
            .map(hId => Household.createHousehold(this, hId));
    }

    getHouseholdForPerson(p) {
        const hId = p.getHouseholdId();
        if (hId) return new WritableHousehold(this, hId);
        return new Household(this, p.getPersonKey());
    }

    groupIntoHouseholds(people, personKeys, callback) {

        /*
            1. Find the person who's household everyone should go into
            2. If no one has a household, create a new one
            3. Write the household id on to everyone
         */


        const peopleToAddToHousehold = personKeys
            //map keys to person objects
            .map(k => people.getPersonAtKey(k))

            //find households for the person objects and also give them a score based on number of members in the HH
            .map(p => {
                const ret = {
                    person: p,
                    household: this.getHouseholdForPerson(p),
                    householdScore: 0
                };

                if (ret.household) {
                    ret.householdScore = ret.household && ret.household.findMembers(people) || 0;
                }
            })
            //Sort them in descending order, so the one with the largest score comes first
            .sort((o1, o2) => {
                const s1 = o1.score;
                const s2 = o2.score;
                return (s1 == s2) ? 0 : ((s1 < s2) ? -1 : +1);
            })
            .map(o => o.person);

        if (!peopleToAddToHousehold || peopleToAddToHousehold.length < 2) {
            return callback(null);
        }

        const headOfHousehold = peopleToAddToHousehold[0];

        //Find the household id to set on everyone
        Promise.resolve(headOfHousehold.getHousehold(this))
            //or create a new one if required
            .then(hh => {
                if (hh) {
                    return hh.id;
                }

                //Make a new title for the household
                const title = peopleToAddToHousehold
                    .reduce((acc, curr) => {
                        acc.push(curr.name);
                        return acc;
                    }, []).join(", ");
                return this.createNewHousehold(title)
                    .then(ref => {
                        return ref.key();
                    });
            })
            .then(id => {
                const peopleWhoNeedAWrite = peopleToAddToHousehold.filter(p => p.getHouseholdId() != id);

                const writePromises = peopleWhoNeedAWrite
                    .map(p => p.setHouseholdId(id));

                return Promise.all(writePromises);
            });
    }

    toString() {
        return `[${this.asArray().map((hh) => hh.toString()).join(", ")}]`;
    }

    _hGetRawHouseholds(hId) {
        if (hId in this._hhs) {
            return this._hhs[hId];
        }
    }

    _hWriteRawHouseholdProperty(hId, propertyName, propertyValue, callback?) {
        //Todo: In draft mode divert writes elsewhere
        return this.__hWriteRawHouseholdProperty(hId, propertyName, propertyValue, callback);
    }

    __hWriteRawHouseholdProperty(hId, propertyName, propertyValue, callback?) {
        //Todo: In draft mode divert writes elsewhere
        return this._ds.writeRsvpHouseholdProperty(hId, propertyName, propertyValue, callback);
    }

    _hCreateRawHousehold(householdObj, callback?) {
        //Todo: In draft mode divert writes elsewhere
        return this.__hCreateRawHousehold(householdObj, callback);
    }

    __hCreateRawHousehold(householdObj, callback?) {
        return this._ds.createRsvpHouseholdsChild(householdObj, callback);
    }
}

export {Households}
